import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import CollectionsIcon from '@mui/icons-material/Collections';
import BlockIcon from '@mui/icons-material/Block';
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect,useMemo } from 'react';
import { getSigns } from "../../slices/sign";
import { getUser } from "../../slices/user";
import ProfileAvatar from "../../components/user/ProfileAvatar";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NiceCollection from "../../components/global/NiceCollection";
import AccountTreeIcon from '@mui/icons-material/AccountTree';


const Collection = ({ collection }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  //const signs = useSelector((state) => state.sign.filter(sign => sign.collection == collection.id));

  const adminUser = useSelector((state) => state.user.users.data.list.find(user => user.username == collection.administrator))

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);

  const collectionSigns = useSelector((state) => state.sign.data.list.filter(sign => sign.collection == collection.id))

  useEffect(() => {

    //if there are no users then we can go get it 
    if (!adminUser){
      let username = collection.administrator
      dispatch(getUser({username}));
    }

    //hit the API to make sure there really art any signs for this collection
    
    if(collectionSigns.length < 1){

      //console.log("Collection: " + collection.name + " Sign: " + collectionSigns)

      const search = {
        page: 0,
        pageSize: 100000,
        collection: collection.id
      }
      dispatch(getSigns({search}));
    }


}, [collection]);

  return (

    
    <Box 
      width="100%"  
      backgroundColor={colors.primary[400]} 
      padding="15px"
      sx={{ borderRadius:2}}
    >
      <Box display="flex" alignItems="flex-start" >
        <CollectionsIcon
          sx={{ color: colors.greenAccent[600], fontSize: "40px" }}
        />
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ color: colors.grey[100] }}
            ml="10px"
          >
            {collection.name}
          </Typography>

          
      </Box>
      <Box display="flex" justifyContent="space-between" mt="20px">
        <Typography>
          {collection.description}
        </Typography>
      </Box>
      <Box 
        display="flex"
        flexDirection="column"
        mt="20px"
        backgroundColor={colors.primary[300]} 
        padding="15px"
        sx={{ borderRadius:1}}
      >
        <Box
          display = "flex"
          flexDirection="row"
          justifyContent="space-between"
          mb="20px">

          <Typography variant="h5">
            Collection is {collection.active ? "active" : "not active"} and holds {collectionSigns?.length} {collectionSigns?.length == 1 ? "Sign" : "signs" }
          </Typography>

          <Box>
          {collection.parentCollection &&
          <>
            <Box display="flex">
            <AccountTreeIcon/>
            <Typography variant="h6" ml="10px">
              
                <NiceCollection>{collection.parentCollection}</NiceCollection>
              
            </Typography>
            </Box>
            </>
            }
          </Box>

        </Box>

        {collectionSigns?.map ((sign) => (
            <Typography key={sign.id}>{sign.id}</Typography>
        ))}
              
        
        
      </Box>

      <Box 
        display="flex"
        flexDirection="column"
        mt="20px"
        backgroundColor={colors.primary[300]} 
        padding="15px"
        sx={{ borderRadius:1}}
      >
        <Box display="flex">
          <AdminPanelSettingsIcon sx={{ fontSize: "30px" }}/>
          <Typography variant="h4" ml="10px">{adminUser?.firstName} {adminUser?.lastName}</Typography>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          mt="10px"
        >
          {adminUser &&
            <ProfileAvatar user = {adminUser} size="75"/>
          }
          <Box
            display="flex"
            flexDirection="column"
            ml="20px"
          >
            <Typography >{adminUser?.username}</Typography>
            <Typography >{adminUser?.email}</Typography>
            

          </Box>
        </Box>

      </Box>


    </Box>
  );
};

export default Collection;
